import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_mst_comp_intercompany_setting_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    comp_guid :fromDatatype.GuidDataFieldInterface;
    comp_code :fromDatatype.VarcharDatatypeInterface;
    config_name :fromDatatype.VarcharDatatypeInterface;
    config_code :fromDatatype.VarcharDatatypeInterface;
    mode :fromDatatype.VarcharDatatypeInterface;
    description :fromDatatype.VarcharDatatypeInterface;
    source_doc_type :fromDatatype.VarcharDatatypeInterface;
    target_doc_type :fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_comp_intercompany_setting_RowClass implements bl_fi_mst_comp_intercompany_setting_RowInterface {
    guid :fromDatatype.GuidDataFieldInterface;
    comp_guid :fromDatatype.GuidDataFieldInterface;
    comp_code :fromDatatype.VarcharDatatypeInterface;
    config_name :fromDatatype.VarcharDatatypeInterface;
    config_code :fromDatatype.VarcharDatatypeInterface;
    mode :fromDatatype.VarcharDatatypeInterface;
    description :fromDatatype.VarcharDatatypeInterface;
    source_doc_type :fromDatatype.VarcharDatatypeInterface;
    target_doc_type :fromDatatype.VarcharDatatypeInterface;
    namespace :fromDatatype.VarcharDatatypeInterface;
    module_guid : fromDatatype.GuidDataFieldInterface;
    applet_guid : fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}